import { useSelector } from "react-redux";
import { useSourceSystem } from "../../hooks/useSourceSystem";
import { isVehicleCommercialVehicle } from "../../pages/helpers";
import {
  getAppraisalData,
  getSourceSystemContent,
  getSourceSystemIsSell,
  getSourceSystemIsCNP,
  selectAppraisal
} from "../../store/selectors";

export const useOfferCard = () => {
  const { valuation, vehicle, promoApplied } = useSelector(getAppraisalData);
  const { isReuseAppraisal } = useSelector(selectAppraisal);
  const { quickValuation } = useSelector(getSourceSystemContent);
  const isSell = useSelector(getSourceSystemIsSell);
  const isCnp = useSelector(getSourceSystemIsCNP);
  const isCommercialVehicle = isVehicleCommercialVehicle(vehicle);
  const {
    sourceSystem: {
      offerCardNoValuationSecondaryText,
      name,
      initialOfferContent: { offerLabel }
    }
  } = useSourceSystem();

  const reuseAppraisalPromo =
    isReuseAppraisal && valuation?.promotionalBonus > 0;

  const offerCopy =
    name !== "branch-appraisal" ? "Your initial valuation" : offerLabel;
  const EstimatedOfferCopy = promoApplied || reuseAppraisalPromo
    ? "Your updated valuation"
    : "Your estimated valuation";

  const noPromo = valuation?.promotionalBonus === 0;

  return {
    valuation,
    promoApplied,
    isSell,
    isCommercialVehicle,
    offerCopy,
    quickValuation,
    isCnp,
    offerCardNoValuationSecondaryText,
    EstimatedOfferCopy,
    noPromo
  };
};
